import { useState, type ReactNode } from 'react';

interface Tab { label: string; content: ReactNode }
interface TabsProps { tabs: Tab[]; defaultIndex?: number }

export default function Tabs({ tabs, defaultIndex = 0 }: TabsProps) {
  const [active, setActive] = useState(defaultIndex);
  return (
    <div>
      <div className="chips" style={{ marginBottom: '16px', marginTop: '8px' }}>
        {tabs.map((t, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`chip${i === active ? ' active' : ''}`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div>{tabs[active]?.content}</div>
    </div>
  );
}
